/**
 * @generated SignedSource<<34081095f351c632b5c7f6a48a856531>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ConfluencePageSubType = "LIVE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type getCachedPageDataSubTypeSearchFragment$data = {
  readonly confluenceEntity: {
    readonly subtype?: ConfluencePageSubType | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "getCachedPageDataSubTypeSearchFragment";
};
export type getCachedPageDataSubTypeSearchFragment$key = {
  readonly " $data"?: getCachedPageDataSubTypeSearchFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCachedPageDataSubTypeSearchFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "getCachedPageDataSubTypeSearchFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "LinkedField",
      "name": "confluenceEntity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "subtype"
            }
          ],
          "type": "ConfluencePage"
        }
      ]
    }
  ],
  "type": "SearchConfluencePageBlogAttachment"
};

(node as any).hash = "029b00b42bd8ba9e9b5ecf4947b241c2";

export default node;
